<template>
  <div class="question">
    <div class="slotWrap">
      <slot />
    </div>
    <div class="buttonBar">
      <div @click="prevClick" :class="prevEnabled ? 'button Enabled' : 'button Disabled'">
        <h3>{{prevTitle}}</h3>
      </div>
      <slot name="bottomButton">
        <div @click="nextClick" :class="nextEnabled ? 'button Enabled' : 'button Disabled'">
          <h3>{{nextTitle}}</h3>
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    prevTitle: String,
    prevEnabled: Boolean,
    nextTitle: String,
    nextEnabled: Boolean
  },
  methods: {
    prevClick: function() {
      if (this.prevEnabled) {
        this.$emit("prevClick");
      }
    },
    nextClick: function() {
      if (this.nextEnabled) {
        this.$emit("nextClick");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.buttonBar {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  padding-bottom: 15px;
}

.question {
  height: auto;
  display: grid;
  grid-template-rows: 1fr auto;
  padding-top: 1em;
  padding-bottom: 1em;
  max-width: 100vw;
  * {
    max-width: 100vw;
  }
}
.slotWrap {
  flex-grow: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -2em;
}
</style>